<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form" v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" md="3">
            <DateIOSPicker label="Ngày" outlined dense outline :rules="[$rules.date]" :date.sync="currentDate" />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedMealSlot"
              :items="mealSlots"
              item-text="title"
              item-value="id"
              label="Bữa ăn *"
              outlined
              dense
              :rules="[$rules.required]"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedMenu"
              :items="menus"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="Đăng ký"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="mealTransferStatus"
              :items="mealTransferStatuses"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="Trạng thái"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
      </v-form>
      <v-row class="mt-3">
        <v-col cols="12">
          <GradeClassStudentSelect @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import { MealSlot } from '@/plugins/api'
import { DEFAULT_SLOT_TITLE } from '@/modules/mealConfig/mealConfigConstants'

export default {
  components: {
    DateIOSPicker,
    GradeClassStudentSelect
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    mealTransferStatus: '',
    selectedMenu: null,
    selectedMealSlot: null,
    mealSlots: [],
    currentDate: moment()
      .startOf('day')
      .toISOString()
  }),
  computed: {
    ...mapGetters('constant', ['menus', 'mealTransferStatuses'])
  },
  methods: {
    ...mapActions('StudentMenuRegister', ['setSelectedSlot']),
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      if (!this.$refs.form.validate()) return
      const slot = this.mealSlots.find(s => String(s.id) === String(this.selectedMealSlot))
      this.setSelectedSlot(slot || null)
      const params = {
        date: this.currentDate,
        mealSlot: this.selectedMealSlot,
        timeOfDay: get(slot, 'timeOfDay'),
        selectedMenu: this.selectedMenu,
        status: this.mealTransferStatus,
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        student: get(this.selectedStudent, 'id')
      }
      this.$emit('onFilterChanged', params)
    }
  },
  created() {
    // Đọc ngày/menu từ URL Ở ĐÂY (trước khi DateIOSPicker con được tạo) để picker khởi tạo
    // đúng ngày. Nếu set sau await trong mounted thì picker đã init với ngày hôm nay + watcher
    // của nó sẽ ghi đè currentDate về lại hôm nay.
    const { date, menu } = this.$route.query
    if (date) this.currentDate = date
    if (menu) this.selectedMenu = menu
  },
  async mounted() {
    this.mealSlots = await MealSlot.fetch({ isActive: true, _limit: -1 })
    const { slot } = this.$route.query
    // mặc định bữa trưa bán trú (hoặc bữa đầu tiên) nếu không có slot từ URL
    const lunch = this.mealSlots.find(s => s.title === DEFAULT_SLOT_TITLE)
    this.selectedMealSlot = slot || get(lunch, 'id') || get(this.mealSlots, '0.id') || null
    this.onFilterChanged()
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
